import { useState, useEffect, useRef } from "react";

const useScroll = (threshold = 15, delay = 150) => {
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const prevScrollY = useRef(window.scrollY);
  const timer = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const diff = currentScrollY - prevScrollY.current;

      if (Math.abs(diff) < threshold) return;

      if (diff < 0) {
        setIsScrollingUp(true);
        setIsScrollingDown(false);
      } else if (diff > 0) {
        setIsScrollingUp(false);
        setIsScrollingDown(true);
      }

      prevScrollY.current = currentScrollY;
    };

    const throttledHandleScroll = () => {
      if (timer.current === null) {
        timer.current = setTimeout(() => {
          handleScroll();
          timer.current = null;
        }, delay);
      }
    };

    window.addEventListener("scroll", throttledHandleScroll);

    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      if (timer.current) clearTimeout(timer.current);
    };
  }, [threshold, delay]);

  return [isScrollingUp, isScrollingDown];
};

export default useScroll;
